import { Component, OnInit } from '@angular/core';
import { SidebarService } from 'src/app/services/sidebar.service';
import { RegistroService } from 'src/app/services/registro.service';
import { ExcelService } from 'src/app/services/excel.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styles: []
})
export class SidebarComponent implements OnInit {

  datos: any;
  cargo: string;
  cargodb: string;
  plantel: string;
  Nombre: string;
  Correo: string;
  idplantel: any;

  menuItems: any[];
  menuItems2: any[];
  menuItems3: any[];
  menuItems4: any[];
  menuItems5: any[];
  menuItems6: any[];
  menuItems7: any[];

  getpermodulos: any = [];

  constructor(
    private excelService: ExcelService,
    private sidebarService: SidebarService,
    private permodulos: RegistroService
  ) {

    // Menús
    this.menuItems2 = sidebarService.menu2;  // RH
    this.menuItems3 = sidebarService.menu3;  // RF
    this.menuItems4 = sidebarService.menu4;  // Usuarios
    this.menuItems6 = sidebarService.menu6;  // Contabilidad
    this.menuItems7 = sidebarService.menu7;  // Materiales

    // Datos usuario
    this.datos = JSON.parse(localStorage.getItem('datos')!);
    this.cargo = this.datos.cargodb?.trim().toUpperCase();
    this.plantel = this.datos.plantel;
    this.Nombre = this.datos.nom;
    this.Correo = this.datos.correop;
    this.idplantel = this.datos.idplantel;
  }

  ngOnInit(): void {

    // 1️⃣ Ocultar todo
    this.ocultarTodo();

    // 2️⃣ Permisos por cargo
    if (this.cargo === 'DIRECTIVO' || this.cargo === 'ADMINISTRATIVO') {

      this.mostrarModulo(this.menuItems);
      this.mostrarModulo(this.menuItems2);
      this.mostrarModulo(this.menuItems3);
      this.mostrarModulo(this.menuItems4);
      this.mostrarModulo(this.menuItems5);
      this.mostrarModulo(this.menuItems6);
      this.mostrarModulo(this.menuItems7);

    } else if (this.cargo === 'RECURSOS HUMANOS') {

      this.mostrarModulo(this.menuItems2);

    } else if (this.cargo === 'RECURSOS FINANCIEROS') {

      this.mostrarModulo(this.menuItems3);

    } else if (this.cargo === 'RECURSOS MATERIALES') {

      this.mostrarModulo(this.menuItems7);

    } else if (this.cargo === 'CONTABILIDAD') {

      this.mostrarModulo(this.menuItems6);
    }

    this.filtrarMenusVacios();

    this.getpetmisosModulos();
  }

  ocultarTodo() {
    [
      this.menuItems,
      this.menuItems2,
      this.menuItems3,
      this.menuItems4,
      this.menuItems5,
      this.menuItems6,
      this.menuItems7
    ].forEach(menu => {
      if (!menu) return;
      menu.forEach(m => {
        if (m.submenu) {
          m.submenu.forEach((s: any) => s.mostrar = false);
        }
      });
    });
  }

  // 🔓 Muestra todos los submenús de un módulo
  mostrarModulo(menu: any[]) {
    if (!menu) return;
    menu.forEach(m => {
      if (m.submenu) {
        m.submenu.forEach((s: any) => s.mostrar = true);
      }
    });
  }

  // ❌ Elimina módulos sin submenús visibles
  filtrarMenusVacios() {
    this.menuItems  = this.menuItems?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems2 = this.menuItems2?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems3 = this.menuItems3?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems4 = this.menuItems4?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems5 = this.menuItems5?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems6 = this.menuItems6?.filter(m => m.submenu?.some((s: any) => s.mostrar));
    this.menuItems7 = this.menuItems7?.filter(m => m.submenu?.some((s: any) => s.mostrar));
  }

  getpetmisosModulos() {
    this.datos = JSON.parse(localStorage.getItem('datos')!);
    this.cargodb = this.datos.cargodb;

    this.permodulos.getpermodulos(this.cargodb).subscribe(
      res => this.getpermodulos = res,
      err => console.log(err)
    );
  }
}
